import React from 'react';

interface IconLineProps {
    children?: React.ReactNode;
}

const IconLine: React.FC<IconLineProps> = ({ children }) => {
    return (
        <div className="fx-r">
            {children?.toString() !== 'false' && (
                <div
                    className="fx-r fx-items-c fx-justify-fs  fx-w  "
                    style={{ gap: 10, borderRadius: 50, minHeight: children?.toString() === 'false' ? 25 : 0 }}
                >
                    {children}
                </div>
            )}
        </div>
    );
};

export default IconLine;
